import React, { memo } from "react";
import VoicePreview from "../../Campaigns/Single/VoicePreview";

function InboundPreview({ InboundArray = [] }) {
  return <VoicePreview voiceArray={InboundArray} />;
}

export default memo(InboundPreview);
